// console.log("updateDisplayBundleCart");
// window.addEventListener('load', function () {
//     updateDisplayBundleMainCart();
// })
setTimeout(() => {
  updateDisplayBundleMainCart();
}, "700");
function updateDisplayBundleMainCart() {
    // js/common/cart/fetch-cart.js
    var fetchCartBundle = new Promise(async (resolve) => {
      resolve(await (await fetch(`${Shopify.routes.root}cart.js`)).json());
    });
    test();
    async function test() {
      var cart = await fetchCartBundle;
  
      // Créer un objet pour regrouper les line items par leur ID de bundle
      const bundledItems = {};
      let cartCount = 0;
      // Parcourir les line items du panier
      cart.items.forEach((item) => {
        const bundleId = item.properties && item.properties._bundleId;
        
        // Vérifier si la propriété _bundleId existe pour l'item en cours
        if (bundleId) {
          // Vérifier si un objet existe déjà pour cet ID de bundle
          if (bundledItems[bundleId]) {
            // Ajouter l'item à l'objet existant pour cet ID de bundle
            bundledItems[bundleId].items.push(item);
          } else {
            // Créer un nouvel objet pour cet ID de bundle et y ajouter l'item
            bundledItems[bundleId] = {
              bundleId: bundleId,
              items: [item]
            };
          }
        } else {
          cartCount = +item.quantity + cartCount
        }
      });
      // L'objet 'bundledItems' contiendra maintenant des objets distincts regroupant les line items ayant la même valeur dans la propriété '_bundleId'
      // Boucle pour itérer sur les valeurs de bundledItems
      Object.values(bundledItems).forEach((bundle) => {
        cartCount = +bundle.items[0].properties._totalBundle + cartCount
        addPackLineItems(bundle)
      });
      console.log(cartCount);
      // Parcourir chaque ligne d'article
      const lineItems = document.querySelectorAll('#mini-cart-form .line-item, .cart .line-item');
      lineItems.forEach(function(lineItem) {
        // Vérifier si la propriété _isBundleChild est égale à true
        // Masquer la ligne d'article si c'est un élément bundle (isBundleChild = true)
        // console.log(lineItem);
        if (lineItem.dataset.isBundleChild === 'true') {
          lineItem.classList.add('display-none');
        }
      });
      updateNbProducts(cartCount);
    }
  
    
    
    // updateNbProducts();
  // ADD Fake packs line item TEST
  function addPackLineItems(bundle) {
    // const parentElementDrawer = document.getElementById('mini-cart-form');
    const parentElementMainCart = document.querySelector('.line-item-table__list');
    
    var bundleTitle = bundle.items[0].properties._bundleTitle;
    var bundleImg = bundle.items[0].properties._bundleImg;
    var totalBundle = bundle.items[0].properties._totalBundle;
    var variantTitleSelected = bundle.items[0].properties._variantTitleSelected;
    var isBundleVariants = bundle.items[0].properties._isBundleVariants;
    var totalBundlePrice = bundle.items[0].properties._totalBundlePrice.toFixed(2);
    var BundleUnitPrice = (totalBundlePrice / totalBundle);
    // var bundlePirce = 0;
    // bundle.items.forEach((item) => {
    //   bundlePirce = bundlePirce + item.final_price;
    // });
    bundlePirceFormat = totalBundlePrice / 100;
    bundleUnitPirceFormat = BundleUnitPrice / 100;
    bundlePirceFormat = "€ " + bundlePirceFormat.toFixed(2);
    bundleUnitPirceFormat = "€ " + bundleUnitPirceFormat.toFixed(2);
    if (isBundleVariants) {

        var cardHtml = `
        <tr class="line-item line-item-custom" id="pack_number_${bundle.bundleId}" >
            <td class="line-item__product">
                <div class="line-item__content-wrapper">
                <a href="/products/zerance-test-5?variant=45253965742353" class="line-item__image-wrapper" tabindex="-1" aria-hidden="true">
                    <img src="${bundleImg}" width="2000" height="2999" loading="lazy" sizes="(max-width: 740px) 80px, 92px" class="line-item__image">
                </a>
                <div class="line-item__info">
                    <div class="product-item-meta">
                    <a href="/products/zerance-test-5?variant=45253965742353" class="product-item-meta__title text--small hidden-tablet-and-up">${bundleTitle}</a>
                    <a href="/products/zerance-test-5?variant=45253965742353" class="product-item-meta__title hidden-phone">${bundleTitle}</a>
                    <div class="product-item-meta__property-list">
                        <span style='color: #6ABA95 ' class="product-item-meta__property text--subdued text--xsmall">${variantTitleSelected}</span>
                    </div>
                    <div class="product-item-meta__price-list-container">
                        <div class="price-list text--small hidden-tablet-and-up">
                        <span style='color: #6ABA95 ;'>
                            <span class="price ">
                            <span class="visually-hidden">Prix de vente</span>
                            <span style='color: #6ABA95 ; font-weight: 700;'>${bundleUnitPirceFormat}</span>
                            </span>
                        </span>
                        </div>

                        <div class="price-list hidden-phone">
                        <span style='color: #6ABA95 ;'>
                            <span class="price">
                            <span class="visually-hidden">Prix de vente</span>
                            ${bundleUnitPirceFormat}</span>
                        </span>
                        </div>
                    </div>
                    </div>
                    <div class="product-item-meta__qty--container hidden-tablet-and-up">
                        <p>Quantité: <span>${totalBundle}</span></p>
                        <a href="/cart" aria-controls="mini-cart" is="toggle-link" aria-label="Panier" data-no-instant class="line-item__remove-button line-item__remove-button_bundle link text--xxsmall" data-no-instant>Supprimer</a>
                    </div>
                </div>
                </div>
            </td>

            <td class="line-item__quantity line-item__quantity--block text--center hidden-phone">
                <div class="product-item-meta__qty--container">
                    <p>Quantité: <span>${totalBundle}</span></p>
                    <a href="/cart" aria-controls="mini-cart" is="toggle-link" aria-label="Panier" data-no-instant class="line-item__remove-button line-item__remove-button_bundle link text--subdued text--xsmall hidden-phone" data-no-instant>Supprimer</a>
                </div>
            </td>

            <td class="line-item__price-list-container text--right hidden-phone">
                <div class="price-list price-list--stack">
                <span>
                    <span class="price ">
                    <span class="visually-hidden">Prix de vente</span><span style='color: #6ABA95 ; font-weight: 700;'>${bundlePirceFormat}</span>
                    </span>
                </span>
                </div>
            </td>
            </tr>
        `
        
    } else {

        var cardHtml = `
        <tr class="line-item line-item-custom" id="pack_number_${bundle.bundleId}" >
            <td class="line-item__product">
                <div class="line-item__content-wrapper">
                <a href="/products/zerance-test-5?variant=45253965742353" class="line-item__image-wrapper" tabindex="-1" aria-hidden="true">
                    <img src="${bundleImg}" width="2000" height="2999" loading="lazy" sizes="(max-width: 740px) 80px, 92px" class="line-item__image">
                </a>
                <div class="line-item__info">
                    <div class="product-item-meta">
                    <a href="/products/zerance-test-5?variant=45253965742353" class="product-item-meta__title text--small hidden-tablet-and-up">${bundleTitle}</a>
                    <a href="/products/zerance-test-5?variant=45253965742353" class="product-item-meta__title hidden-phone">${bundleTitle}</a>
                    <div class="product-item-meta__price-list-container">
                        <div class="price-list text--small hidden-tablet-and-up">
                        <span style='color: #6ABA95 ;'>
                            <span class="price ">
                            <span class="visually-hidden">Prix de vente</span>
                            <span style='color: #6ABA95 ; font-weight: 700;'>${bundleUnitPirceFormat}</span>
                            </span>
                        </span>
                        </div>

                        <div class="price-list hidden-phone">
                        <span style='color: #6ABA95 ;'>
                            <span class="price">
                            <span class="visually-hidden">Prix de vente</span>
                            ${bundleUnitPirceFormat}</span>
                        </span>
                        </div>
                    </div>
                    </div>
                    <div class="product-item-meta__qty--container hidden-tablet-and-up">
                        <p>Quantité: <span>${totalBundle}</span></p>
                        <a href="/cart" aria-controls="mini-cart" is="toggle-link" aria-label="Panier" data-no-instant class="line-item__remove-button line-item__remove-button_bundle link text--xxsmall" data-no-instant>Supprimer</a>
                    </div>
                </div>
                </div>
            </td>

            <td class="line-item__quantity line-item__quantity--block text--center hidden-phone">
                <div class="product-item-meta__qty--container">
                    <p>Quantité: <span>${totalBundle}</span></p>
                    <a href="/cart" aria-controls="mini-cart" is="toggle-link" aria-label="Panier" data-no-instant class="line-item__remove-button line-item__remove-button_bundle link text--subdued text--xsmall hidden-phone" data-no-instant>Supprimer</a>
                </div>
            </td>

            <td class="line-item__price-list-container text--right hidden-phone">
                <div class="price-list price-list--stack">
                <span>
                    <span class="price ">
                    <span class="visually-hidden">Prix de vente</span><span style='color: #6ABA95 ; font-weight: 700;'>${bundlePirceFormat}</span>
                    </span>
                </span>
                </div>
            </td>
        </tr>
        `
  
    }
    if (parentElementMainCart) {
        parentElementMainCart.insertAdjacentHTML( 'afterbegin', cardHtml );
    }
    removePackLineItems(bundle.bundleId);
    
  }
  
  function updateNbProducts(cartCount) {
    const miniCartProductCount = document.querySelector(`.mini-cart_count`);
    const headerProductCount = document.querySelector(`.header__cart-count`);
    console.log(headerProductCount);
    // console.log(totalNbProduct);
    if (miniCartProductCount){
        miniCartProductCount.innerHTML = cartCount;
    }
    // console.log(headerProductCount);
    // console.log(totalNbProduct);
    console.log("cartCount");
    console.log(cartCount);
    headerProductCount.innerHTML = cartCount;
    console.log(headerProductCount);
  
  }
  // Remove Fake packs line item AND Remove content of packs by shopify cart API
  function removePackLineItems(packIdSplit) {
    const cartRmovePackButtons = document.querySelectorAll(`#pack_number_${packIdSplit} .line-item__remove-button_bundle`);
     
    cartRmovePackButtons.forEach((cartRmovePackButton) => {
        cartRmovePackButton.addEventListener("click", async (el) => {
            var cart = await fetchCartBundle;
            // now have access to Shopify cart object
            let updates = {};
            cart.items.forEach((item) => {
                if (item.properties != undefined && item.properties._bundleId != undefined) {
                    if (parseInt(item.properties._bundleId) == parseInt(packIdSplit)) {
                        item.quantity = 0;
                        updates[item.key] = 0;
                    }
                }
            });
            
            const cartContent = await (await fetch(`${Shopify.routes.root}cart/update.js`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                updates,
                sections: ["mini-cart"]
              })
            })).json();
  
            document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
              bubbles: true,
              detail: {
                cart: cartContent
              }
            }));
            // document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            //   bubbles: true,
            //   detail: {
            //     cart: cartContent,
            //     openMiniCart: window.themeVariables.settings.cartType === "drawer" && this.closest(".drawer").open
            //   }
            // }));
            
            location.reload();   
            
            
        });
    });
  }
    
   
}

// updateDisplayBundleCartPage();